import type { ContentPart, CatalogRow, StreamEvent } from '../types/chat';

export function parseStreamLine(line: string): StreamEvent | null {
  const trimmed = line.trim();
  if (!trimmed) return null;
  if (!trimmed.startsWith('data:')) throw new Error('Invalid stream line format');
  const json = trimmed.slice(5);
  const obj = JSON.parse(json);
  if (!obj || typeof obj.type !== 'string' || !('data' in obj))
    throw new Error('Invalid stream event');
  return obj;
}

export function eventToContentPart(evt: StreamEvent): ContentPart | null {
  switch (evt.type) {
    case 'content':
      return { kind: 'text', text: evt.data.content };
    case 'tool_call':
      return { kind: 'tool_call', name: evt.data.name, args: evt.data.args, id: evt.data.id };
    case 'tool_result': {
      const md = evt.data.result.metadata;
      const display = md?.display_type;
      const rows = (evt.data.result.results ?? []) as CatalogRow[];
      if (display === 'table') {
        return {
          kind: 'tool_result',
          tool_call_id: evt.data.tool_call_id,
          display: 'table',
          rows,
          metadata: { start_date: md?.start_date, end_date: md?.end_date }
        };
      }
      if (display === 'default' || !display) {
        return {
          kind: 'tool_result',
          tool_call_id: evt.data.tool_call_id,
          display: 'default',
          rows,
          metadata: { start_date: md?.start_date, end_date: md?.end_date }
        };
      }
      return { kind: 'notice', text: `Unsupported display_type: ${String(display)}` };
    }
    case 'complete':
      return { kind: 'notice', text: `Stream ${evt.data.status}` };
    default: {
      throw new Error('Invalid stream event type');
    }
  }
}
